import React from 'react'
import { useDispatch } from 'react-redux'
import styles from './VideoEdit.module.scss'

import { PencilSimpleIcon, SparkleIcon, TrashIcon } from '@phosphor-icons/react'
import { ScoopMenu, ScoopMenuItem, ScoopMenuDivider, ScoopButton } from '../../../ui'

import { deleteVideo, updateVideoContent } from '../../../../store/actions'
import { useModal, MODALS } from '../../../modals'

export default function VideoEdit({ setIsMenuOpen, id }) {
    const [anchorEl, setAnchorEl] = React.useState(null)
    const dispatch = useDispatch()
    const deleteModal = useModal(MODALS.COMMON.DELETE)
    const addVideoModal = useModal(MODALS.CANVAS.ADD_VIDEO)

    const open = Boolean(anchorEl)

    const handleClick = (event) => {
        setIsMenuOpen(true)
        setAnchorEl(event.currentTarget)
    }

    const handleClose = () => {
        setIsMenuOpen(false)
        setAnchorEl(null)
    }

    const createMenuItemHandler = (handler) => (event) => {
        event.stopPropagation()
        handler()
        setAnchorEl(null)
        setIsMenuOpen(false)
    }

    const handleDelete = () => {
        dispatch(deleteVideo(id))
        setIsMenuOpen(false)
        setAnchorEl(null)
    }

    const handleEditVideo = async () => {
        const result = await addVideoModal.show()
        if (result?.videoURL) {
            dispatch(updateVideoContent(id, { videoURL: result.videoURL }))
        }
        setIsMenuOpen(false)
    }

    return (
        <>
            <div style={{ width: '100%' }}>
                <ScoopButton
                    variant="text"
                    size="xxs"
                    aria-label="Open menu"
                    className={styles.iconButton}
                    onClick={handleClick}
                    style={{ backgroundColor: 'transparent' }}
                >
                    <SparkleIcon size={32} weight="fill" className={styles.sparkleIcon} />
                </ScoopButton>
                <ScoopMenu
                    anchorEl={anchorEl}
                    open={open}
                    onClose={handleClose}
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                    transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                    onMouseDown={(e) => e.stopPropagation()}
                >
                    <ScoopMenuItem
                        leftSection={<PencilSimpleIcon size={18} weight="regular" />}
                        primary="Edit"
                        onClick={createMenuItemHandler(handleEditVideo)}
                    />
                    <ScoopMenuDivider />
                    <ScoopMenuItem
                        leftSection={<TrashIcon size={18} weight="regular" />}
                        primary="Delete"
                        onClick={createMenuItemHandler(() =>
                            deleteModal.show({
                                title: 'this video',
                                type: 'Video',
                                onDelete: handleDelete,
                            })
                        )}
                    />
                </ScoopMenu>
            </div>
        </>
    )
}
